const doc = [({"da":({"js":({"admin":({"suppliers":({"select":({"choose_supplier":"Vælg leverandør"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;